

import React from "react";
import { Dropdown } from "./Dropdown";
import { CountryModel } from "@/app/models/timesheet/countryModel";
import { CountryFlag } from "@/modules/shared/components/CountryFlag";
import { useBusinessTripRatesRowContext } from "../context/BusinessTripRatesRowContext";
import { useBusinessTripRatesTableContext } from "../context/BusinessTripRatesTableContext";

type Props = {
    value: CountryModel
    availableCountries: CountryModel[]
    handleChange: (country: string) => void
}

export const CountryInput = (props : Props) => {
    const {
        value,
        availableCountries,
        handleChange,
    } = props
    const {
        // rates,
        savedRates,
        // availableCountries,
        // availableCurrencies,
        // handleUpdate,
        // handleDelete,
      } = useBusinessTripRatesTableContext()
    const { rate } = useBusinessTripRatesRowContext()
    const saved = savedRates.find((sr) => sr.id === rate.id)
    const isDirty = !saved || Boolean(
        saved.country.code !== rate.country.code
    )

    return (
        <>
            <Dropdown
                portalPosition='to-left'
                options={availableCountries.map((c) => ({ label: `${c.code} ${c.name}`, value: c.code }))}
                value={value?.code}
                // name={currencyName}
                onChange={handleChange}
                className="tw-text-right" 
                renderOption={(optCode) => {
                    const opt = availableCountries.find(c => c.code === optCode.option.value)
                    return (
                        <div className="tw-flex tw-justify-start tw-gap-2 tw-items-center">
                            {opt && opt.code && (<CountryFlag code={opt.code} />)}
                            <span>{opt.name || "---"}</span>
                        </div>
                    )
                }}
            >   
                <div className="tw-flex tw-justify-start tw-gap-2 tw-items-center">
                    {value && value.code && <CountryFlag code={value.code} className="tw-min-h-[16px] tw-min-w-[24px]"/>}
                    <span className={isDirty ? 'tw-text-red-400' : ''}>{value?.name || "---"}</span>
                </div>
            </Dropdown>
        </>
    )
}
